import React from 'react';
// redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { passwordReset } from '../../../redux/reducers/auth';
// components
import Form from '../../../components/Form/Form';
import FieldError from '../../../components/Form/FieldError';
import FormErrors from '../../../components/Form/FormErrors';
import PasswordInput from '../../../components/PasswordInput/PasswordInput';
import Button from '../../../components/Button/Button';
// utils
import { toast } from 'react-toastify';
import { withFormik } from 'formik';
import * as yup from 'yup';
import { responseErrors } from '../../../utils/response';
import validations from '../../../utils/validations';
// styles
import styles from './ChangePasswordForm.mod.css';

export const ChangePasswordForm = ({
  values,
  touched,
  errors = {},
  dirty,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit,
  closeModal,
}) => (
  <Form className={styles.formWrapper} onSubmit={handleSubmit}>
    <h2>Change password</h2>
    <br />
    <FormErrors errors={errors.full_messages || errors} />

    <div className="form-control">
      <div className="field-wrapper mb-20">
        <PasswordInput
          name="current_password"
          placeholder="Current Password"
          value={values.current_password}
          onChange={handleChange}
          onBlur={handleBlur}
          invalid={errors.current_password && touched.current_password}
        />
        <FieldError
          error={errors.current_password}
          touched={touched.current_password}
        />
      </div>
    </div>

    <div className="form-control">
      <div className="field-wrapper mb-20">
        <PasswordInput
          name="password"
          placeholder="New Password"
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
          invalid={errors.password && touched.password}
        />
        <FieldError error={errors.password} touched={touched.password} />
      </div>
    </div>

    <div className="form-control">
      <div className="field-wrapper mb-20">
        <PasswordInput
          name="password_confirmation"
          placeholder="Repeat Password"
          value={values.password_confirmation}
          onChange={handleChange}
          onBlur={handleBlur}
          invalid={
            errors.password_confirmation && touched.password_confirmation
          }
        />
        <FieldError
          error={errors.password_confirmation}
          touched={touched.password_confirmation}
        />
      </div>
    </div>
    <div className={styles.buttons}>
      <Button link onClick={closeModal}>
        Close
      </Button>
      <Button
        type="submit"
        primary
        isLoading={isSubmitting}
        disabled={isSubmitting}
      >
        Submit
      </Button>
    </div>
  </Form>
);

export default compose(
  connect(
    null,
    { passwordReset }
  ),
  withFormik({
    mapPropsToValues: () => ({
      current_password: '',
      password: '',
      password_confirmation: '',
    }),
    validationSchema: yup.object().shape({
      current_password: yup.string().required('Current password is required!'),
      password: validations.password,
      password_confirmation: yup
        .string()
        .oneOf([yup.ref('password'), null], "Passwords don't match")
        .required('Password confirm is required!'),
    }),
    handleSubmit: (
      values,
      { setSubmitting, setErrors, props: { passwordReset, closeModal } }
    ) => {
      passwordReset(values)
        .then(() => {
          setSubmitting(false);
          toast.info('Your password successfully changed.');
          closeModal();
        })
        .catch(response => {
          setErrors(responseErrors(response));
          setSubmitting(false);
        });
    },
    displayName: 'ChangePasswordForm',
  })
)(ChangePasswordForm);



// WEBPACK FOOTER //
// ./src/containers/UserProfile/components/ChangePasswordForm.jsx